import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getIntersectionList, getSectionList, saveIntersection, searchGroups } from 'Root/http';
import { isSupervisorUser } from 'Auth/redux/auth.redux';
import { getLocationQuery } from 'shared/utils/url';

import NotificationSidebar from './Sidebar/NotificationSidebar';
import NotificationUsers from './NotificationUsers/NotificationUsers';
import NotificationSettings from './NotificationSettings/NotificationSettings';

import s from './style/Notifications.pcss';
import Loader from '../../../shared/components/Loader/Loader';


@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class Sections extends React.Component {
  static propTypes = {
    match: PropTypes.shape().isRequired,
    location: PropTypes.shape().isRequired,
    isSupervisor: PropTypes.bool.isRequired,
  };


  state = {
    loading: false,
    selected: [],
    sections: [],
    intersections: [],
    groups: [],
    total: 0,
  };


  componentDidMount() {
    this.setState({ dataLoading: true }, () => {
      this.loadSections().then((sections) => {
        this.setState({ sections, dataLoading: false }, this.loadData);
      });
    });
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { sectionId } }, location } = this.props;
    const { match: { params: { sectionId: prevSectionId } }, location: prevLocation } = prevProps;

    const query = getLocationQuery(location);
    const prevQuery = getLocationQuery(prevLocation);
    const needUpdate = (prevSectionId !== sectionId) || (prevQuery.type !== query.type) ||
      (prevQuery.page !== query.page) || (prevQuery.search !== query.search);

    if (needUpdate) {
      this.setState({ loading: true }, () => {
        this.loadData();
      });
    }
  }

  loadData = () => {
    const { match: { params: { sectionId } }, location } = this.props;
    const query = getLocationQuery(location);

    if (sectionId) {
      switch (query.type) {
        case 'users': {
          this.loadIntersections(sectionId).then(({ intersections, total }) => {
            this.setState({
              intersections,
              groups: [],
              total,
              loading: false,
            });
          });

          break;
        }

        case 'groups': {
          this.loadGroups().then((groups) => {
            this.setState({
              intersections: [],
              groups,
              loading: false,
            });
          });

          break;
        }

        default: break;
      }
    } else {
      this.setState({ intersections: [], groups: [], loading: false });
    }
  }

  loadSections = () => {
    const { isSupervisor } = this.props;
    return getSectionList(isSupervisor)
      .then(data => Promise.resolve(data));
  };

  loadIntersections = (sectionId) => {
    const query = getLocationQuery(this.props.location);
    const querySearchString = query.search || '';

    return getIntersectionList(sectionId, null, querySearchString)
      .then((data) => {
        const intersections = data.payload;
        return Promise.resolve({ intersections, total: data.total });
      });
  };

  loadGroups = () => {
    const query = getLocationQuery(this.props.location);
    const searchData = { value: query.search || '' };

    return searchGroups(searchData).then(data => data.list.reduce(
      (resultGroupsList, group) => (group.obj ? resultGroupsList.concat(group.obj) : resultGroupsList),
      [],
    ));
  };

  handleSave = (data) => {
    const body = {
      ...data,
      sectionId: this.props.match.params.sectionId,
    };

    saveIntersection(body)
      .then(() => {
        const sectionId = this.props.match.params.sectionId;
        this.loadIntersections(sectionId)
          .then(({ intersections, total }) =>
            this.setState({ intersections, selected: [], total }));
      });
  };

  handleSelectUsers = selected => this.setState({ selected });

  render() {
    const { sections, loading, dataLoading, intersections, groups, selected, total } = this.state;
    const users = intersections.map(int => int.userId);

    const query = getLocationQuery(this.props.location);
    const selectedIntersections = query.type === 'users' ?
      intersections.filter(user => selected.includes(user.userId.id)) :
      groups.filter(group => selected.includes(group.id));

    if (dataLoading) {
      return (
        <Loader />
      );
    }

    return (
      <div className={s.container}>
        <NotificationSidebar data={sections} />
        <NotificationUsers
          loading={loading}
          users={users}
          total={total}
          groups={groups}
          onSelectUser={this.handleSelectUsers}
          selected={selected}
        />
        <NotificationSettings
          intersectionsType={query.type}
          intersections={selectedIntersections}
          onSave={this.handleSave}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Notifications/index.js